module.exports = __webpack_public_path__ + "img/theme3.5fcb9958.png";